import { GetterTree } from 'vuex';
import { NewsletterState } from '@/store/modules/newsletter/types';
import { RootState } from '@/store/types';

export const getters: GetterTree<NewsletterState, RootState> = {
    /**
     * Check if newsletter module is enabled.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    newsletterModuleEnabled: (state, nlGetters, rootState, rootGetters): boolean => {
        // return rootGetters.permissionEnabled('newsletter') &&
        //     rootGetters.getPreferenceByKey('mailup.enabled') === 'enabled';
        return rootGetters.getPreferenceByKey('mailup.enabled') === 'enabled';
    },

    /**
     * Check if mailup username and password are set.
     * @param state
     * @param nlGetters
     * @param rootState
     * @param rootGetters
     */
    mailupCredentialsSet: (state, nlGetters, rootState, rootGetters): boolean => {
        return !!rootGetters.getPreferenceByKey('mailup.username') &&
            !!rootGetters.getPreferenceByKey('mailup.password');
    },

    /**
     * Return the specified recipient.
     *
     * @param state
     */
    getRecipientByEmail: (state) => (email: string) => {
        return state.activeListRecipients.find((recipient) => recipient.email === email);
    },

    /**
     * Return the specified group.
     *
     * @param state
     */
    getGroupById: (state) => (id: number) => {
        return state.activeListGroups.find((group) => group.idGroup === id);
    },

    /**
     * Return the specified group recipient.
     *
     * @param state
     */
    getGroupRecipientById: (state) => (groupId: number, recipientId: number) => {
        return state.activeGroupsRecipients.find((recipient) => {
            return recipient.idGroup === groupId && recipient.idRecipient === recipientId;
        });
    },

    /**
     * Return the count of lists
     *
     * @param state
     */
    listCount: (state): number => state.lists.length,
};
